var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PagedResponse_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { decodeToken, encodeToken } from './continuationToken';
import { pagedResponseSchemaValidation } from '../validations.generated';
export const pagedResponseSchema = {
    $id: 'urn:wisepipe-common:PagedResponse',
    type: 'object',
    properties: {
        continuationToken: { type: 'string' },
        items: { type: 'array', items: { type: 'object' } }
    },
    required: ['items']
};
let PagedResponse = PagedResponse_1 = class PagedResponse {
    constructor(items, continuationToken) {
        this.items = items;
        this.continuationToken = continuationToken;
        JSON.validate(this, PagedResponse_1);
    }
    static getSerdeMap(func) {
        return new Map([['items', func]]);
    }
    static fromTwoResponses(responseV1, responseV2) {
        // expected that the continuation Token is already encoded
        const continuationToken = responseV1?.continuationToken ? decodeToken(responseV1.continuationToken) : undefined;
        const continuationTokenV2 = responseV2?.continuationToken ? decodeToken(responseV2.continuationToken) : undefined;
        // there should never be a case where one is encrypted with different algo
        // but one could be undefined and the other not
        const tokenAlgoVersion = continuationToken ? continuationToken.version : 2;
        const tokenV2AlgoVersion = continuationTokenV2 ? continuationTokenV2.version : 2;
        const items = [];
        if (responseV1)
            items.push(...responseV1.items);
        if (responseV2)
            items.push(...responseV2.items);
        return new PagedResponse_1(items, encodeToken({
            token: continuationToken?.token,
            tokenV2: continuationTokenV2?.token,
            // since an undefined token sets version to 2, we default to the other token's property if it exists
            version: tokenAlgoVersion && tokenV2AlgoVersion
        }));
    }
};
PagedResponse = PagedResponse_1 = __decorate([
    JsonSchemaV2(pagedResponseSchema, pagedResponseSchemaValidation)
], PagedResponse);
export { PagedResponse };
//# sourceMappingURL=pagedResponse.js.map